import React, { useEffect } from "react";

const Contact = () => {
  useEffect(() => {
    document.title = "Contact";
  }, []);
    return <h1>Contact Me</h1>;
  };
  
  export default Contact;   